export default __webpack_public_path__ + "static/case_img2-ad725916bebaa4ac0d6a1f8f041354de.webp";